










































































































































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import FormResumeRalan from "@/components/pemeriksaan/resumeSuketV2/FormResumeRalan.vue";
import CardDPP from "@/components/pemeriksaan/soap/CardDPP.vue";
import { userModule } from "@/store/modules/user";
import DataResume from "@/services/DataResume";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import { storeResume } from "@/store/modules/resume";
import ResumeRalan from "@/services/ResumeRalan";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import FormPrefillService from "@/services/FormPrefillService";
import router from "@/router";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import { confirmRemove } from "@/utility/CommonHelper";
import HydrationGuard from "@/mixins/HydrationGuard";
import { ResumeRalanBlanko } from "@/types/resumeRalanBlanko";
import {
  blankoDariPayload,
  blankoMasihKosong,
  dariPrefill,
  isiYangKosong,
  ringkasIcd
} from "@/utils/resumeRalanBlanko";

const CARA_PULANG_LABEL: Record<string, string> = {
  pulang: "Pulang",
  pulang_paksa: "Pulang Paksa",
  rujuk: "Rujuk",
  rawat_inap: "Rawat Inap",
  meninggal: "Meninggal"
};

interface PayloadTersimpan {
  discharge_id: string | number;
  ttd?: boolean;
}

const CARA_PULANG_SLUG: Record<string, string> = {
  "1": "pulang",
  "2": "rujuk",
  "3": "pulang_paksa",
  "4": "meninggal",
  "5": "rawat_inap"
};

@Component({
  components: {
    CardModalTtd,
    FormResumeRalan,
    CardDPP,
    ModalKonfirmasi
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardResumeRalan extends Mixins(HydrationGuard) {
  @Prop() readonly register!: string;
  @Prop() readonly rm!: string;
  /** Deep-link dari tombol "Buat Resume" di tab SOAP / Resep. */
  @Prop({ type: Boolean, default: false }) readonly bukaFormLangsung!: boolean;
  @Prop({ default: null }) readonly bukaFormNonce!: number | null;
  @Prop({ type: Boolean, default: false }) readonly dalamDialog!: boolean;
  isReadOnly!: () => boolean;

  form: ResumeRalanBlanko | null = null;
  formResumeId: string | null = null;
  saving = false;
  modeUbah = false;
  ubahFormLama = false;
  bukaSesudahMuat = false;
  deleting = false;
  modalOpen = false;
  menandatangani = false;
  rantaiTertunda: PayloadTersimpan | null = null;
  enableQuickSign = false;
  modalOpenKonfirmasi = false;
  msgConfirm = "";
  sumberGagal: Array<string> = [];
  pageTab = "tab-soap";

  get readOnlyMode(): boolean {
    return this.isReadOnly();
  }

  get terkunci(): boolean {
    return this.busy || this.saving || this.deleting || this.readOnlyMode;
  }

  get stateresume() {
    return storeResume.resume;
  }

  get stateuser() {
    return userModule.user;
  }

  get adaResume(): boolean {
    return !!(this.stateresume && this.stateresume[0]);
  }

  get resumeId(): string | null {
    const row: any = this.stateresume[0];

    return row && row.id != null ? String(row.id) : null;
  }

  get formLama(): boolean {
    const row: any = this.stateresume[0];

    return !!row && row.form_versi === "lama";
  }

  get namaDischarge(): string {
    const row: any = this.stateresume[0];

    return row && row.discharge ? row.discharge.nama || "" : "";
  }

  get catatan(): string {
    const row: any = this.stateresume[0];

    return row && row.catatan ? String(row.catatan) : "";
  }

  get namaDpjp(): string {
    const row: any = this.stateresume[0];

    return row && row.dpjp ? row.dpjp.nama : "";
  }

  get diagnosisIcd(): Array<any> {
    const row: any = this.stateresume[0];

    return row && row.diagnosis ? row.diagnosis : [];
  }

  get prosedurIcd(): Array<any> {
    const row: any = this.stateresume[0];

    return row && row.prosedur ? row.prosedur : [];
  }

  get caraPulangSlug(): string | null {
    const row: any = this.stateresume[0];
    if (!row) return null;

    return CARA_PULANG_SLUG[String(row.discharge_id)] || null;
  }

  get namaCaraPulang(): string {
    const slug = this.caraPulangSlug;
    if (slug) return CARA_PULANG_LABEL[slug];

    const row: any = this.stateresume[0];

    return row && row.discharge ? row.discharge.nama : "";
  }

  get ringkasanTampilan(): Array<{ label: string; nilai: string }> {
    const f = this.form;
    if (!f) return [];

    const fisik = [
      f.pf_ku ? `Ku: ${f.pf_ku}` : "",
      f.pf_kesadaran ? `Kesadaran: ${f.pf_kesadaran}` : "",
      f.pf_td ? `Tensi: ${f.pf_td} mmHG` : "",
      f.pf_nafas ? `Pernafasan: ${f.pf_nafas} x/menit` : "",
      f.pf_suhu ? `Suhu: ${f.pf_suhu} °C` : "",
      f.pf_nadi ? `Nadi: ${f.pf_nadi} x/menit` : "",
      f.pf_tinggi_badan ? `TB: ${f.pf_tinggi_badan} cm` : "",
      f.pf_berat_badan ? `BB: ${f.pf_berat_badan} kg` : "",
      f.pf_lain || ""
    ]
      .filter(teks => !!teks)
      .join(" · ");

    const tindakLanjut = this.ringkasTindakLanjut(f);

    const baris = [
      { label: "Keluhan Utama", nilai: f.keluhan_utama },
      { label: "Alergi", nilai: f.alergi },
      { label: "Riwayat Penyakit Sekarang", nilai: f.riwayat_penyakit_sekarang },
      { label: "Riwayat Penyakit Dulu", nilai: f.riwayat_penyakit_dahulu },
      { label: "Riwayat Penyakit Keluarga", nilai: f.riwayat_penyakit_keluarga },
      { label: "Pemeriksaan Fisik", nilai: fisik },
      { label: "Laboratorium", nilai: f.penunjang_lab },
      { label: "Pemeriksaan Radiologi", nilai: f.penunjang_radiologi },
      { label: "Penunjang Lain", nilai: f.penunjang_lain },
      { label: "Diagnosa Akhir", nilai: f.diagnosa_akhir },
      { label: "Terapi / Tindakan", nilai: f.terapi_tindakan },
      { label: "Tindak Lanjut", nilai: tindakLanjut },
      { label: "Kontrol", nilai: this.ringkasKontrol(f) }
    ];

    return baris
      .filter(item => !!item.nilai && String(item.nilai).trim() !== "")
      .map(item => ({ label: item.label, nilai: String(item.nilai) }));
  }

  ringkasKontrol(f: ResumeRalanBlanko): string {
    if (!f.tl_kontrol) return "";

    const bagian = [
      f.tl_tgl_kontrol ? "Tanggal " + f.tl_tgl_kontrol : "",
      f.tl_kontrol_note ? "Tujuan " + f.tl_kontrol_note : ""
    ].filter(teks => !!teks);

    return bagian.length ? bagian.join(" · ") : "Ya";
  }

  ringkasTindakLanjut(f: ResumeRalanBlanko): string {
    if (f.tl_status === "stabil") {
      const opsi = [
        f.tl_prb ? "Program Rujuk Balik" : "",
        f.tl_iterasi
          ? `Iterasi${f.tl_prb_note ? " " + f.tl_prb_note : ""}`
          : "",
        f.tl_rujuk_balik_fktp ? "Rujuk Balik FKTP" : ""
      ].filter(teks => !!teks);

      return `Stabil${opsi.length ? " — " + opsi.join(", ") : ""}`;
    }

    if (f.tl_status === "tidak_stabil") {
      return "Tidak Stabil";
    }

    return "";
  }

  get bolehTtd(): boolean {
    if (this.readOnlyMode) return false;

    const row: any = this.stateresume[0];

    return (
      this.stateuser.profesi == "Dokter" &&
      !!row &&
      row.signed == "0" &&
      !!row.dpjp &&
      this.stateuser.id == row.dpjp.id
    );
  }

  get canSign(): boolean {
    return !this.busy && this.bolehTtd;
  }

  get canRemove(): boolean {
    if (this.readOnlyMode) return false;

    const row: any = this.stateresume[0];
    if (!row || row.id == null || !row.dpjp) return false;
    if (this.stateuser.id != row.dpjp.id) return false;

    return !alasanTtdMengunciHapus(
      row.user && row.user.id,
      [
        {
          ditandatangani: ["1", "true"].includes(String(row.signed)),
          penandaTanganId: row.dpjp.id
        }
      ],
      this.stateuser.id
    );
  }

  @Watch("register", { immediate: true })
  changedRegister() {
    this.muatForm();
  }

  @Watch("resumeId")
  changedResumeId(baru: string | null) {
    if (!this.loaded || this.saving || this.deleting) return;
    if (baru === this.formResumeId) return;

    if (!baru) {
      this.pasangForm(null);

      return;
    }

    if (this.form) return;

    const reg = this.register;
    this.sumberGagal = [];

    this.hydrate(async () => {
      if (String(reg) !== String(this.register)) return;

      await this.siapkanForm(reg);
    }).then(() => this.bukaJikaTertunda());
  }

  pasangForm(row: any) {
    this.form = row ? blankoDariPayload(row) : null;
    this.formResumeId = row && row.id != null ? String(row.id) : null;
  }

  async siapkanForm(reg: string) {
    const row: any = this.stateresume[0];

    this.pasangForm(row);

    if (!this.form) return;
    if (this.formLama) return;
    if (!blankoMasihKosong(this.form)) return;

    await this.tarikDariRme(reg);
  }

  bukaForm() {
    this.ubahFormLama = this.formLama;
    this.modeUbah = true;
  }

  bukaJikaTertunda() {
    if (!this.bukaSesudahMuat) return;

    this.bukaSesudahMuat = false;
    this.bukaForm();
  }

  /**
   * Datang dari tombol "Buat/Ubah Resume" di tab SOAP atau Resep: halaman ini
   * dibuka lewat deep-link dan form langsung terbentang, tanpa klik kedua.
   */
  @Watch("bukaFormNonce", { immediate: true })
  onDeepLinkForm() {
    if (!this.bukaFormLangsung) return;
    if (this.readOnlyMode) return;

    this.$nextTick(() => {
      if (this.busy) {
        this.bukaSesudahMuat = true;

        return;
      }

      this.bukaForm();
    });
  }

  /** Jalur "Buat SKDP": form ditutup di sini, lalu rail Suket pindah ke kartu SKDP. */
  async teruskanSkdp(payload: any) {
    this.modeUbah = false;
    await this.muatForm();

    this.$emit("buat-skdp", payload);
  }

  async setelahSimpan(payload: PayloadTersimpan) {
    this.modeUbah = false;
    await this.muatForm();

    if (payload && payload.ttd && this.bolehTtd) {
      this.rantaiTertunda = payload;
      this.modalOpen = true;

      return;
    }

    // Diteruskan ke rail Suket untuk rantai SPRI / Surat Rujukan.
    this.$emit("tersimpan", payload);
  }

  @Watch("modalOpen")
  onGantiModalTtd(buka: boolean) {
    if (buka || this.menandatangani) return;

    this.lanjutkanRantai();
  }

  lanjutkanRantai() {
    const payload = this.rantaiTertunda;
    this.rantaiTertunda = null;

    if (payload) this.$emit("tersimpan", payload);
  }

  async muatForm() {
    const reg = this.register;
    if (!reg) {
      this.loaded = true;

      return;
    }

    this.sumberGagal = [];
    this.pasangForm(null);

    await this.hydrate(async () => {
      await storeResume.act_resume_on_reg({ reg, idUser: "" });
      if (String(reg) !== String(this.register)) return;

      await this.siapkanForm(reg);
    });

    this.bukaJikaTertunda();
  }

  async tarikDariRme(reg: string) {
    if (!this.form) return;

    const prefill: any = await FormPrefillService.fetchPrefill(
      this.rm,
      "resume_ralan",
      {
        register_id: reg,
        unit_id: this.stateuser.unit_id,
        sources: ["anamnesis_terkini", "klinis_terkini"]
      }
    );

    if (String(reg) !== String(this.register) || !this.form) return;

    this.sumberGagal = prefill ? [] : ["anamnesis & TTV"];

    const terisi = isiYangKosong(
      this.form,
      dariPrefill(prefill ? prefill.fields : null)
    );

    terisi.push(
      ...isiYangKosong(this.form, {
        diagnosa_akhir: ringkasIcd(this.diagnosisIcd),
        terapi_tindakan: ringkasIcd(this.prosedurIcd),
        tgl_surat: moment().format("YYYY-MM-DD")
      })
    );

    if (terisi.length && prefill) {
      FormPrefillService.logAcceptance({
        form_key: "resume_ralan",
        pasien_rm: this.rm,
        register_id: reg,
        unit_id: this.stateuser.unit_id,
        event: "accepted",
        fields: terisi,
        provenance: {},
        sources: prefill.sources
      });
    }

    return terisi;
  }

  cetak() {
    const row: any = this.stateresume[0];
    if (!row) return;

    window.open(
      this.formLama
        ? ResumeRalan.jknPdfUrl(row.id)
        : ResumeRalan.blankoPdfUrl(row.id),
      "_blank"
    );
  }

  modalTtd() {
    this.modalOpen = true;
  }

  passTtd(value) {
    const row: any = this.stateresume[0];
    if (!row || !row.dpjp) return;

    appModule.setLoading(true);
    this.menandatangani = true;

    DataResume.saveDataTtdResume(this.register, row.dpjp.id, value)
      .then((dt: any) => {
        const body = dt && dt["data"] ? dt["data"] : null;

        if (!body || body["status"] != 1) {
          appModule.addMsgTtd(
            body && body["message"] ? body["message"] : "Gagal tanda tangan"
          );
          this.menandatangani = false;
          this.modalOpen = true;

          return;
        }

        this.modalOpen = false;
        appModule.NoticeDelay("Berhasil Tanda Tangan Resume Ralan");
        appModule.addMsgTtd("");
        storeResume.act_resume_on_reg({ reg: this.register, idUser: "" });

        this.menandatangani = false;
        this.lanjutkanRantai();
      })
      .finally(() => {
        this.menandatangani = false;
        appModule.setLoading(false);
      });
  }

  quickSign() {
    if (!this.enableQuickSign) return;

    appModule.setLoading(true);

    ResumeRalan.quickSign(this.register)
      .then(dt => {
        if (dt.data.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan Resume Ralan");
          storeResume.act_resume_on_reg({ reg: this.register, idUser: "" });
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.enableQuickSign = false;
      });
  }

  getHumanDateTime(date) {
    return date ? moment(date).format("DD MMMM YYYY HH:mm:ss") : "";
  }

  exitPemeriksaan() {
    router.push("/dashboard-poliklinik");
  }

  deleteResume() {
    if (!confirmRemove("Resume Ralan")) return;
    if (this.deleting) return;

    const row: any = this.stateresume[0];
    if (!row) return;

    this.deleting = true;

    ResumeRalan.remove(row.id)
      .then(resp => {
        if (resp.data && resp.data.status == 1) {
          appModule.NoticeDelay("Berhasil Hapus Resume Ralan");

          storeResume.act_resume_on_reg({ reg: this.register, idUser: "" });
          this.pasangForm(null);
        } else {
          appModule.sendErrorAlert(
            (resp.data && resp.data.message) || "Gagal menghapus Resume Ralan"
          );
        }
      })
      .finally(() => {
        this.deleting = false;
      });
  }
}
